module.exports = __webpack_public_path__ + "static/media/mapTaxiRight.92743bf8.png";